import { render, staticRenderFns } from "./PlanejamentoDpmDeclaracaoCompra.vue?vue&type=template&id=46c2a3ad&scoped=true&"
import script from "./PlanejamentoDpmDeclaracaoCompra.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoDpmDeclaracaoCompra.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoDpmDeclaracaoCompra.vue?vue&type=style&index=0&id=46c2a3ad&scoped=true&lang=css&"
import style1 from "./PlanejamentoDpmDeclaracaoCompra.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c2a3ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VRow})
